import { rem } from 'polished';
import styled from 'styled-components';
import { DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT, getMaxPageWidth } from '../../constants';
import { breakpoints } from '../../styles/theme';
import IconTemplate from "@components/Icon";

export const DesktopTop = styled.div`
    margin-top: ${rem(MOBILE_HEADER_HEIGHT)};
    display: none;
    flex-direction: row;
    justify-content: space-between;
    gap: ${rem(25)};

    @media (min-width: ${breakpoints.sm}px) {
        margin-top: ${rem(DESKTOP_HEADER_HEIGHT)};
    }

    @media (min-width: ${breakpoints.md}px) {
        display: flex;
    }
`;

export const Content = styled.div`
    padding: ${rem(10)} 0;
    width: 100%;
`;

export const Banner = styled.img`
    width: ${rem(320)};
    border-radius: ${rem(16)};
    cursor: pointer;
`;

export const Sidebar = styled.div`
    min-width: ${rem(320)};
    max-width: ${rem(320)};
`;

export const Mobile = styled.div`
    display: block;
    padding: ${rem(20)} ${rem(20)};
    margin-top: ${rem(MOBILE_HEADER_HEIGHT)};

    @media (min-width: ${breakpoints.md}px) {
        display: none;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
`;

export const Favourite = styled.span`
    font-size: ${({ theme }) => theme.fontSizes.textBase};
    cursor: pointer;
    margin-bottom: ${rem(5)};
`;

export const FavouriteIcon = styled(IconTemplate)`
    svg {
        width: ${rem(23)};
        height: ${rem(17)};

        path {
            fill: ${({ theme }) => theme.colors.primary};
        }
    }
`;
